// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.BooleanFilterValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { FilterValue } from "abweb/dto/inputargs/FilterValue";
export class BooleanFilterValueBase extends FilterValue {
  /** Do NOT invoke directly, instead use strongly typed createBooleanFilterValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.BooleanFilterValue";
  }
  initFromJson(json, deserializeContext) {
    this.initBooleanFilterValue(json.componentGuid != null ? json.componentGuid : null, json.value != null ? json.value : null);
  }
  initBooleanFilterValue(componentGuid, value) {
    this.initFilterValue(componentGuid);
    this._value = value;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._value != null) {
      retVal["value"] = this._value;
    }
    return retVal;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
//# sourceMappingURL=BooleanFilterValueBase.js.map
